import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';

import {TranslateModule} from '@ngx-translate/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ClickOutsideModule} from 'ng-click-outside';
import {TextMaskModule} from 'angular2-text-mask';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';

const MODULES = [
  ClickOutsideModule,
  CommonModule,
  FormsModule,
  NgbModule,
  ReactiveFormsModule,
  RouterModule,
  TextMaskModule,
  TranslateModule,
];

/**
 * Utility module containing commonly needed imports.
 *
 * In future, if a module is added to the application and then imported throughout, that module should go here.
 *
 */
@NgModule({
  imports: [
    ...MODULES,
  ],
  exports: [
    ...MODULES,
  ]
})
export class SharedModule {
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/shared/shared.module.ts